'use client'
import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Divider, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useERACustomizer } from 'src/contexts/era-package/EraCustomizerContext';

const ParentCard = ({ title, children, footer, codeModel, sx, ...props }) => {
  const customizer = useERACustomizer()

  const theme = useTheme();
  const borderColor = theme.palette.divider;

  return (
    <Card
      sx={{ padding: 0, border: !customizer.isCardShadow ? `1px solid ${borderColor}` : 'none', ...sx }}
      elevation={customizer.isCardShadow ? 9 : 0}
      variant={!customizer.isCardShadow ? 'outlined' : undefined}
      {...props}
    >
      <CardHeader title={title} action={codeModel} sx={{ color: theme.palette.primary.main }} />
      <Divider />
      <CardContent>{children}</CardContent>
      {footer &&
        <>
          <Divider />
          <Box p={3}>{footer}</Box>
        </>
      }
    </Card>
  );
};

ParentCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  footer: PropTypes.node,
};

export default ParentCard;
